import React from "react";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import Main from "./pages/Home";
import Page404 from "./pages/404";
import WithAuth from "./components/HOC/withauth";
import DashboardPage from "pages/Dashboard";
import Helper from "pages/yardim";
import SayacVerileri from "pages/sayacVerileri";
import TesisatDetay from "pages/TesisatDetay";
import TesisatDetaylariOSF from "components/TesisatDetaylari/OSF";
import TesisatDetaylariAylikEndex from "components/TesisatDetaylari/AylikEndex";
import TesisatDetaylariDurumGrafikleri from "components/TesisatDetaylari/DurumGrafikleri";
import UserOperationsPage from "pages/UserOperations";
import GunBazindaEndex from "components/TesisatDetaylari/GunBazindaEndex";
import TesisatDetaylariYukProfili from "components/TesisatDetaylari/YukProfili";
import RegisterPage from "pages/register";
import SecureRoute from "helpers/SecureRoute";
import Forbidden from "pages/Forbidden";

class Router extends React.Component {
  render() {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SecureRoute><Main /></SecureRoute>}></Route>
          <Route path="/forbidden" element={<SecureRoute><Forbidden /></SecureRoute>}></Route>
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/dashboard" element={<SecureRoute><DashboardPage /></SecureRoute>}></Route>
          <Route path="/helper" element={<SecureRoute><Helper /></SecureRoute>}></Route>
          <Route path="/sayac-verileri" element={<SecureRoute><SayacVerileri /></SecureRoute>}></Route>
          <Route path="/tesisat-detaylari/:id" element={<SecureRoute><TesisatDetay /></SecureRoute>}>
            <Route
             path="/tesisat-detaylari/:id/osf"
              element={<SecureRoute><TesisatDetaylariOSF /></SecureRoute>}
            ></Route>
              <Route
             path="/tesisat-detaylari/:id/yuk-profili"
              element={<SecureRoute><TesisatDetaylariYukProfili /></SecureRoute>}
            ></Route>
            <Route
              path="/tesisat-detaylari/:id/aylik-endex"
              element={<SecureRoute><TesisatDetaylariAylikEndex /></SecureRoute>}
            ></Route>
            <Route
            path="/tesisat-detaylari/:id/durum-grafikleri"
              element={<SecureRoute><TesisatDetaylariDurumGrafikleri /></SecureRoute>}
            ></Route>
             <Route
             path="/tesisat-detaylari/:id/gun-bazinda-endex"
              element={<SecureRoute><GunBazindaEndex /></SecureRoute>}
            ></Route>
          </Route>
          <Route
            path="/kullanici-islemleri"
            element={<SecureRoute><UserOperationsPage /></SecureRoute>}
          ></Route>
          <Route path="*" element={<SecureRoute><Page404 /></SecureRoute>}></Route>
        </Routes>
      </BrowserRouter>
    );
  }
}

export default WithAuth(Router);
